<div>
    <div class="flex justify-content-between align-items-center mb-3">
        <h2>Importaciones de datos</h2>
        <button *ngIf="allowWrite" pButton label="Nueva importación" icon="pi pi-plus" (click)="showCreate = true"></button>
    </div>

    <p-table [value]="imports" [loading]="loading" responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th>Tipo</th>
                <th>Modo</th>
                <th>Estado</th>
                <th>Progreso</th>
                <th>Procesadas</th>
                <th>Importadas</th>
                <th>Errores</th>
                <th>Creada</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td>
                    {{ typeLabels[row.importType] }}
                    <p-tag *ngIf="row.dryRun" value="Prueba" severity="info" styleClass="ml-2"></p-tag>
                </td>
                <td>{{ modeLabels[row.mode] }}</td>
                <td><p-tag [severity]="statusSeverity[row.status]" [value]="statusLabels[row.status]"></p-tag></td>
                <td><p-progressBar [value]="row.progressPercent"></p-progressBar></td>
                <td>{{ row.processedRows }} / {{ row.totalRows }}</td>
                <td>{{ row.importedRows }}</td>
                <td>{{ row.errorRows }}</td>
                <td>{{ row.createdAt | date:'short' }}</td>
                <td>
                    <div class="flex gap-2 justify-content-end">
                        <p-button (click)="openDetail(row.id)" [rounded]="true" [text]="false" pTooltip="Ver detalle"><i class="pi pi-eye"></i></p-button>
                        <p-button (click)="downloadFile(row.fileId)" [rounded]="true" [text]="false" pTooltip="Descargar fichero"><i class="pi pi-download"></i></p-button>
                        <p-button *ngIf="allowDelete && row.status !== 'EnCurso'" (click)="askDelete(row)" [rounded]="true" [text]="false" severity="danger" pTooltip="Eliminar"><i class="pi pi-trash"></i></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr><td colspan="9" class="text-center p-4">No hay importaciones.</td></tr>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="showCreate" header="Nueva importación" [modal]="true" [style]="{width: '600px'}">
        <app-imports-create *ngIf="showCreate" (created)="onCreated()" (cancelled)="showCreate=false"></app-imports-create>
    </p-dialog>

    <p-confirmDialog></p-confirmDialog>
</div>
